// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vpchjcjtpvhiethwwrpr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZwY2hqY2p0cHZoaWV0aHd3cnByIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgxNTI0NzcsImV4cCI6MjA1MzcyODQ3N30.rocLg4yHl8deCsKf0k8Al1kvQCzJrCBx2vbO2UfqPNg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);